import { render, staticRenderFns } from "./NavBarCardapio.vue?vue&type=template&id=1047706b"
import script from "./NavBarCardapio.vue?vue&type=script&lang=js"
export * from "./NavBarCardapio.vue?vue&type=script&lang=js"
import style0 from "./NavBarCardapio.vue?vue&type=style&index=0&id=1047706b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports